export enum MediaCategories {
  Media = 'media',
  Blog = 'blog',
  Video = 'video',
  Other = 'other',
  Latest = 'latest',
}
